module.exports = __webpack_public_path__ + "static/media/yellow_dots2.b3349ca3.svg";